// Reader download status objects, filled in by the backend's handlebars pass
// (system.pdf / system.downloads.<format>; empty when the format is off).
// Read by dotell-assets engagement-bar.js.
export const pdfData = `
<script>
  window.pdf = {
    url: "{{system.pdf.url}}",
  };
  window.sdDownloads = {
    pptx: { url: "{{system.downloads.pptx.url}}" },
    images: { url: "{{system.downloads.images.url}}" },
  };
</script>
`;
